var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',[_c('div',{staticClass:"manageItem",on:{"click":_vm.enterColleague}},[_c('i',{staticClass:"el-icon-s-help"}),_c('div',{staticClass:"text"},[_vm._v("同事管理")])])])}
var staticRenderFns = []

export { render, staticRenderFns }